import { Alert, Checkbox, Container, FormControlLabel, Grid, Paper, styled } from '@mui/material';
import { Box } from '@mui/system';
import React, { Component } from 'react';
import Constantes from '../php/Constantes';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    }));

class SaldoFuncionarios extends Component {
    constructor(props){
        super(props);
        this.state = {

            datos: {
                numeroFuncionario: '',
            },

            notificaciones: null,
            errores: null,
            horasSimples: '0',
            reglamentaria: null,
            anti: null,
            horasInhabile: '0',
            enfermedadFamiliar: '0',
            estudio: '0',
            diasTurismo: '0',
            acta: '0',
            internacion: '0',
            ley: '0',
            especial: '0',
            nombreUsu: '',
            covid: '',
            liceCon: '',
            suspendida: '',

            consulta: false,

        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
    }
    async componentDidMount(){

    }
    render(){
        return (
            <>
                <Container>
                    <form className='formulario'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                        <h3>Saldo Funcionario</h3>
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.1}>
                                    <Item>Número de Funcionario <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.datos.numeroFuncionario} onChange={this.manejarCambiosDatos} type="number" /></Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Container>
                <Container>
                    {this.state.consulta
                    ?
                        <Container>
                            <fieldset>
                                <legend>FUNCIONARIO: {this.state.nombreUsu}</legend>
                                <br/>
                                <br/>
                                <legend>REGLAMENTARIA</legend>
                                {this.state.suspendida != null
                                ?
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={2.5}>
                                                <Item style={{color: 'red'}}>LICENCIA REGLAMENTARIA SUSPENDIDA</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>{this.state.suspendida.totalDias}</Item>
                                            </Grid>
                                            <Grid item xs={0.5}>
                                                
                                            </Grid>
                                            <Grid item xs={2.5}>
                                                <Item style={{color: 'red'}}>EJERCICIO</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>{this.state.suspendida.ejercicio}</Item>
                                            </Grid>
                                            <Grid item xs={0.5}>
                                                
                                            </Grid>
                                        </Grid>
                                        <br/>
                                    </Box>
                                :
                                    null
                                }
                                {this.state.reglamentaria.map((name, index) => (
                                    <Box sx={{ flexGrow: 1}} key={index}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={2.5}>
                                                <Item>LICENCIA REGLAMENTARIA</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>{name.diasDisponibles}</Item>
                                            </Grid>
                                            <Grid item xs={0.5}>
                                                
                                            </Grid>
                                            <Grid item xs={2.5}>
                                                <Item>EJERCICIO</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>{name.anio}</Item>
                                            </Grid>
                                            <Grid item xs={0.5}>
                                                
                                            </Grid>
                                        </Grid>
                                        <br/>
                                    </Box>
                                ))}
                                {this.state.anti.map((name, index) => (
                                    <Box sx={{ flexGrow: 1}} key={index}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2.5}>
                                                <Item>ANTIGÜEDAD</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>{name.diasDisponibles}</Item>
                                            </Grid>
                                            <Grid item xs={0.5}>
                                                
                                            </Grid>
                                            <Grid item xs={2.5}>
                                                <Item>EJERCICIO</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>{name.anio}</Item>
                                            </Grid>
                                            <Grid item xs={0.5}>
                                                
                                            </Grid>
                                        </Grid>
                                        <br/>
                                    </Box>
                                ))}
                            </fieldset>
                            <br/>
                            <br/>
                                
                            <fieldset>
                                <legend>HORAS PENDIENTES</legend>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={1}>
                                                
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>HORAS SIMPLES</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.horasSimples.horasTotal} minutos</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>HORAS INHABILES</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.horasInhabile.horasTotal} minutos</Item>
                                        </Grid>
                                        <Grid item xs={0.5}></Grid>
                                    </Grid>
                                </Box>
                            </fieldset>
                            <br/>
                            <br/>
                            <fieldset>
                                <legend>DIAS PENDIENTES</legend>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={1}>
                                                
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>ENFERMEDAD FAMILIAR</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.enfermedadFamiliar.diasTotal}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>ESTUDIO / (EXAMEN, PARCIAL)</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.estudio.diasTotal}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={1}>
                                                
                                        </Grid>
                                        <Grid item xs={1}>
                                                
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>DIAS INHABILES / TURISMO</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.diasTurismo.diasTotal}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>ACTA 1694</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.acta.diasTotal}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={1}>
                                                
                                        </Grid>
                                        <Grid item xs={1}>
                                                
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>INTERNACION FAMILIAR</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.internacion.diasTotal}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>LEY 17242</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.ley.diasTotal}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={1}>
                                                
                                        </Grid>
                                        <Grid item xs={1}>
                                                
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>LICENCIA ESPECIAL 30 AÑOS</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.especial.diasTotal}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                                
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>LICENCIA EX. COVID</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.covid.diasTotal}</Item>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </fieldset>
                            <br/>
                            <br/>
                        </Container>
                    :
                        null
                    }
                </Container>
            </>
        )//Final return
    }//Final render

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.datos;
            funcionarioActualizado[clave] = valor;
            return{
                datos: funcionarioActualizado,
            };
        })
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if((this.state.datos.numeroFuncionario === '')){
            this.setState({
                errores: 'DEBE INGRESAR UN NÚMERO DE FUNCIONARIO!',
            });
        }else{
            const carga = JSON.stringify(['', this.state.datos.numeroFuncionario]);

            const res = await fetch(`${Constantes.RUTA_API}/guardar_licencia.php`,{
                method: 'POST',
                body: carga,
            })

            const cargaUtil = JSON.stringify([this.state.datos]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_SaldoFuncionario.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito[0],
                notificaciones: null,
                consulta: false,
            });

            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    horasSimples: exito[11],
                    reglamentaria: exito[4],
                    anti: exito[5],
                    horasInhabile: exito[2],
                    enfermedadFamiliar: exito[7],
                    estudio: exito[8],
                    diasTurismo: exito[1],
                    acta: exito[3],
                    internacion: exito[9],
                    ley: exito[6],
                    especial: exito[10],
                    covid: exito[13],
                    nombreUsu: exito[12],
                    liceCon: exito[14],
                    consulta: true,
                    suspendida: exito[15],
                });
            }
        }
    }
}

export default SaldoFuncionarios